import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	CreateSessionLogInput,
	FilterQueryInput,
	GetAllMentorsAPIResponse,
	GetAllSessionsAPIResponse,
	GetBookedSessionsByIdAPIResponse,
	GetMentorAvailabilitiesAPIResponse,
	GetParticipantToken,
	GetSessionByIdAPIResponse,
	GetSessionRecordingByIdAPIResponse,
	ParticipantSessionFeedbackInput,
	ScheduleSessionInput,
} from 'types';

const baseUrl = `${API_ENDPOINT}/session`;

export const getRecordingBySessionId = async (sessionId: string): Promise<GetSessionRecordingByIdAPIResponse> => {
	try {
		const response = await baseApi.get(`${baseUrl}/getRecordingsBySessionId/${sessionId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const endSession = async (sessionId: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/end-session/${sessionId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const getAllSessions = async (filterData?: FilterQueryInput): Promise<GetAllSessionsAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/host/all`, filterData);
	return response.data;
};

export const submitParticipantFeedback = async (args?: ParticipantSessionFeedbackInput): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/levelupSubmitParticipantFeedback/`, args);
	return response.data;
};

export const getAllMentors = async (): Promise<GetAllMentorsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/getMentors`);
	return response.data;
};

export const createParticipantSessionToken = async ({
	sessionId,
	participantSlug,
	token,
	isGuestUser,
}: {
	sessionId: string;
	participantSlug?: string;
	token?: string;
	isGuestUser?: boolean;
}): Promise<GetParticipantToken> => {
	try {
		const response = await baseApi.post(`${baseUrl}/create-participant-session-token?token=${token}`, {
			sessionId,
			participantSlug,
			isGuestUser,
		});
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const getAllBookedParticipantSessions = async (
	levelUpParticipantId?: string,
): Promise<GetBookedSessionsByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/levelUpParticipant/${levelUpParticipantId}`);
	return response.data;
};

export const getSessionById = async (id: string, token: string): Promise<GetSessionByIdAPIResponse> => {
	console.log('LevelUp: inside getSessionById: sessionId useGetSessionByIdQuery', id, token);
	const response = await baseApi.get(`${baseUrl}/getSessionById/${id}?token=${token}`);
	return response.data;
};

export const scheduleMentorSession = async (args: ScheduleSessionInput): Promise<GetSessionByIdAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/scheduleMentorSession/`, args);
	return response.data;
};

export const getMentorAvailabilities = async (mentorId: string): Promise<GetMentorAvailabilitiesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/availableMentorSlots/${mentorId}`);
	return response.data;
};

export const createSessionLog = async (args: CreateSessionLogInput): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.post(`${baseUrl}/create-logs?token=${args?.token}`, args);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const startSession = async (sessionId: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/start-session/${sessionId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};
export const verifyToken = async ({ token }: { token: string }): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.post(`${baseUrl}/verifyToken`, {
			token,
		});
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};
